"use client"

import { usePlausible } from "next-plausible"
import { usePostHog } from "posthog-js/react"
import { useCallback } from "react"
import { isDev } from "~/env"

export type TrackEventOptions = {
  /** Plausible event name when legacy dashboards use a different name than PostHog. */
  plausibleEventName?: string
}

/**
 * Custom hook that tracks events on the client side. Memoized so effects can
 * safely list the returned function as a dependency (both upstream hooks
 * return stable references).
 */
export const useTrackEvent = () => {
  const plausible = usePlausible()
  const posthog = usePostHog()

  return useCallback(
    (eventName: string, properties?: Record<string, unknown>, options?: TrackEventOptions) => {
      if (isDev) {
        console.log("Tracking event:", eventName, properties, options)
        return
      }

      const plausibleName = options?.plausibleEventName ?? eventName
      plausible(plausibleName, { props: properties })
      posthog?.capture(eventName, properties)
    },
    [plausible, posthog],
  )
}
